const normalizeDstId = (dstId) =>
  Array.isArray(dstId)
    ? dstId.filter(Boolean)
    : dstId != null && dstId !== ""
      ? [dstId]
      : [];

export const getParentMessageEmail = (item) => {
  if (!item) return "";
  if (typeof item === "string") return item.trim();
  const email = item.parent_email || item.email || item.mail || "";
  if (email) return String(email).trim();
  const name = typeof item.name === "string" ? item.name.trim() : "";
  return name.includes("@") ? name : "";
};

export const buildRecruiterStudentParentPayload = ({
  messageBody,
  dstId,
  email,
  sendToStudent = false,
  sendToParent = false,
  attachmentUrl,
  isInternational = false,
  single = false,
  useParentEmail = false,
}) => {
  const trimmedEmail = typeof email === "string" ? email.trim() : "";
  const payload = {
    message_body: messageBody,
  };

  if (useParentEmail) {
    if (trimmedEmail) {
      payload.email = trimmedEmail;
    }
  } else {
    payload.dst_id = normalizeDstId(dstId);
  }

  if (sendToStudent && sendToParent) {
    payload.event_type = "recruiter_student";
    payload.parent_ack = true;
  } else if (sendToParent) {
    payload.event_type = "recruiter_parent";
    payload.parent_ack = true;
  } else {
    payload.event_type = "recruiter_student";
  }

  if (isInternational) {
    payload.is_international = true;
    payload.event_type = "international_student";
  }

  if (attachmentUrl) {
    payload.attachment_url = attachmentUrl;
  }

  if (single) {
    payload.single = true;
  }

  return payload;
};

export const hasRecruiterStudentParentSelection = (sendToStudent, sendToParent) =>
  Boolean(sendToStudent || sendToParent);
